import type { ChartTheme } from './chartTheme'

/**
 * Half a category either side of the chosen one, in axis units.
 *
 * A category axis takes a fractional index, and a band's edges are exactly
 * half a step out from its centre — so the shading covers that year's column
 * and nothing of its neighbours'.
 */
const HALF_BAND = 0.5

/** Which year the reader has open, or nothing if the axis does not carry it. */
export const ageIndex = (
  ages: string[],
  age: string | undefined
): number | undefined => {
  if (age === undefined) return undefined
  const index = ages.indexOf(age)
  return index === -1 ? undefined : index
}

/**
 * The year the reader has open, drawn as the column it is.
 *
 * A band rather than a rule, because a rule is what a milestone is: two marks
 * drawn the same way have to be told apart by colour, and next to retirement
 * the open year read as a second milestone (the chip is what says which is
 * which, and the open year has no chip).
 *
 * Silent, so a tap on the band still reaches the plot underneath and moves the
 * selection rather than being swallowed by what reports it.
 */
export const buildMarkArea = (
  theme: ChartTheme,
  selectedIndex?: number
): object | undefined => {
  if (selectedIndex === undefined) return undefined

  return {
    silent: true,
    itemStyle: { color: theme.selection.bandColor },
    data: [
      [
        { xAxis: selectedIndex - HALF_BAND },
        { xAxis: selectedIndex + HALF_BAND },
      ],
    ],
  }
}
